<div #modalRef class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content" *ngIf="!recuperar_acceso">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Iniciar Sesión</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form>
          <div class="mb-1">
            <label for="usuario" class="col-form-label">Usuario:</label>
            <input #usuario type="text" class="form-control" id="usuario" />
          </div>
          <div class="mb-2">
            <label for="password" class="col-form-label">Contraseña:</label>
            <input #contrasnena type="password" class="form-control" id="password" />
          </div>
        </form>
      </div>
      <div class="modal-footer mx-4">
        <button type="button" class="btn mr-2 btn-warning" (click)="onRecuperarAcceso()">
          Recuperar acceso
        </button>
        <button type="button" class="btn mr-2 btn-secondary" data-bs-dismiss="modal">
          Cancelar
        </button>
        <button type="button" class="btn mr-2 btn-primary" (click)="onAccederClick(usuario.value, contrasnena.value)">
          Acceder
        </button>
      </div>
    </div>

    <div class="modal-content" *ngIf="recuperar_acceso">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Recuperar Acceso</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form>
          <div class="mb-1">
            <label for="correo" class="col-form-label">Correo:</label>
            <input #correo type="text" class="form-control" id="correo" />
          </div>
        </form>
      </div>
      <div class="modal-footer mx-4">
        <button type="button" class="btn mr-2 btn-warning" (click)="onCancelarRecuperacion()">
          Regresar a Login
        </button>
        <button type="button" class="btn mr-2 btn-primary" (click)="onConfirmarRecuperarAcceso(correo.value)">
          Confirmar
        </button>
      </div>
    </div>
  </div>
</div>